export var fixKeyValueArraysToJsObject = function fixKeyValueArraysToJsObject(records) {
  return records.map(function (r) {
    var _Object$assign;

    return Object.assign({}, (_Object$assign = {}, _Object$assign[r.key] = r.value, _Object$assign.type = r.__type, _Object$assign));
  });
};
export default {
  fixKeyValueArraysToJsObject: fixKeyValueArraysToJsObject
};